import CompanyBasicInformation from '../../../../../components/reusable/report/cards/CompanyBasicInformation';
import CompanyManager from './CompanyManager';
import BuyReportWrapper from '../components/BuyReportWrapper';

const Basic = ({ handleBuyReport }) => {
  const companyData = {
    companyCode: 211454910,
    creditinfoId: 35347,
    companyName: 'LOREM IPSUM, UAB',
    status: 'Active subject',
    statusHistory: [
      {
        dateFrom: '2011-10-06T00:00:00Z',
        status: 'Active subject',
      },
      {
        dateFrom: '2011-06-28T00:00:00Z',
        dateTo: '2011-10-06T00:00:00Z',
        status: 'Participating in reorganization process',
      },
      {
        dateFrom: '1993-09-24T00:00:00Z',
        dateTo: '2011-06-28T00:00:00Z',
        status: 'Active subject',
      },
    ],
    legalForm: 'Municipal State Enterprise for Specific Purpose',
    registered: '1993-09-24T00:00:00Z',
    vatCode: 'LT114549113',
    vatRegistrationDate: '1995-01-01T00:00:00Z',
    nace2: '473000 - Retail sale of automotive fuel',
    municipality: 'Vilnius municip.',
    ruleOfRepresentation: 10,
    ruleOfRepresentationDescription: 'Juridinio asmens vardu veikia vadovas',
    target:
      'automobilių degalų mažmeninė prekyba specializuotose parduotuvėse; kietojo, skystojo ir dujinio kuro bei priedų didmeninė prekyba; degalų, rūdų, metalų ir pramoninių cheminių preparatų pardavimo agentų veikla; mažmeninė prekyba nespecializuotose parduotuvėse, kuriose vyrauja maistas, gėrimai ir tabakas; kita naujų prekių mažmeninė prekyba specializuotose parduotuvėse; kita veikla, neprieštaraujanti įstatymams',
    institutionalSector: {
      sectorId: 11003,
      sectorDescription: 'Ne finansų bendrovės - Kontroliuojamos užsienio subjektų',
    },
    internationalSanction: {
      companyCode: 211454910,
      creditinfoId: 35347,
      isInternationalSanctioned: false,
    },
    isAfterBankruptcy: false,
    registrationFormHistory: [
      {
        dateFrom: '1993-09-24T00:00:00Z',
        dateTo: '1996-05-28T00:00:00Z',
        name: 'Branch of the credit Union',
      },
    ],
    previousCompanyNames: [
      {
        dateFrom: '2005-01-14T00:00:00Z',
        dateTo: '2012-12-05T00:00:00Z',
        name: 'UAB "LOREM IPSUM"',
      },
      {
        dateFrom: '1996-05-28T00:00:00Z',
        dateTo: '2005-01-14T00:00:00Z',
        name: 'Uždaroji akcinė bendrovė "LOREM IPSUM"',
      },
    ],
  };

  const manager = {
    managerData: {
      companyCode: 211454910,
      creditinfoId: 35347,
      managerFullName: 'Vardenis Pavardenis, Generalinis direktorius',
      birthDate: '1973-02-20T00:00:00Z',
      dateFrom: '2015-10-01T00:00:00Z',
      managerCreditinfoId: 1476613,
    },
  };

  return (
    <BuyReportWrapper type={'basicInformation'} handleBuyReport={handleBuyReport}>
      <div className="content-blur">
        <CompanyBasicInformation companyData={companyData} />
        <CompanyManager managerData={manager.managerData} managersHistory={manager.managersHistory} />
      </div>
    </BuyReportWrapper>
  );
};

export default Basic;
